import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/pages/home/bonus-zone';
import {navigate} from '../../../../../utils/navigation';

export default () => {
    const {user} = useSelector(Selector);

    return (
        <div className="col bonus-zone" onClick={e => navigate('/tasks')}>
            <div className="content">
                <div className="info">
                    <div className="title">Bonus Zone</div>
                    <div className="text">Complete tasks and unlock bonus rewards</div>
                </div>

                {
                    user
                    ? (
                        <>
                            <div className="bonus-zone-details">
                                <div className="diamonds">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M6.36705 11.335L1.01384 11.1324L3.05566 6.86328L6.36705 11.335Z" fill="#A0EBFF"/>
                                        <path d="M12.1366 19.1342L1.0133 11.1325L6.36651 11.3356L12.1366 19.1342Z" fill="#41B4E6"/>
                                        <path d="M12.1371 19.1351L6.36704 11.3365L9.80193 10.4199L13.2338 9.49558L13.2383 9.49821L12.1371 19.1351Z" fill="#A0EBFF"/>
                                        <path d="M6.36713 11.3346L3.05574 6.86287L8.60348 5.94791L6.36713 11.3346Z" fill="#73C8F0"/>
                                        <path d="M12.1363 19.1342L13.2376 9.49734L17.7706 6.63949L12.1363 19.1342ZM13.233 9.49471L9.80115 10.4191L6.36626 11.3356L8.60319 5.9482L13.233 9.49471Z" fill="#41B4E6"/>
                                        <path d="M13.2329 9.49594L8.6029 5.94913L13.8648 3.96769L13.2329 9.49594Z" fill="#73C8F0"/>
                                        <path d="M13.8648 3.96737L8.60286 5.9488L3.05513 6.86376L8.14837 4.23956L13.8648 3.96737Z" fill="#A0EBFF"/>
                                        <path d="M9.80074 10.4199L12.1363 19.1361L13.2373 9.49906L13.2331 9.49664L9.80074 10.4199Z" fill="#77E2FF"/>
                                        <path d="M12.137 19.1347L13.2382 9.49785L17.7713 6.64L12.137 19.1347ZM13.2334 9.4964L9.8011 10.4196L8.60756 5.95202L13.2334 9.4964Z" fill="#1EA6E1"/>
                                        <path d="M13.2329 9.49594L8.60701 5.95157L8.60287 5.94918L13.8648 3.96769L13.2329 9.49594Z" fill="#4EBAEC"/>
                                        <path d="M13.8648 3.96778L8.6028 5.94927L8.14835 4.23997L13.8648 3.96778Z" fill="#77E2FF"/>
                                        <path d="M13.2371 9.49804L17.7702 6.64019L13.8652 3.96777L13.2326 9.49541L13.2371 9.49804Z" fill="#77E2FF"/>
                                    </svg>

                                    {user ? user.diamonds : 0}
                                </div>
                                <span>Diamonds</span>
                            </div>

                            <div className="mobile-details">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                    <path d="M6.36705 11.335L1.01384 11.1324L3.05566 6.86328L6.36705 11.335Z" fill="#A0EBFF"/>
                                    <path d="M12.1366 19.1342L1.0133 11.1325L6.36651 11.3356L12.1366 19.1342Z" fill="#41B4E6"/>
                                    <path d="M12.1371 19.1351L6.36704 11.3365L9.80193 10.4199L13.2338 9.49558L13.2383 9.49821L12.1371 19.1351Z" fill="#A0EBFF"/>
                                    <path d="M6.36713 11.3346L3.05574 6.86287L8.60348 5.94791L6.36713 11.3346Z" fill="#73C8F0"/>
                                    <path d="M12.1363 19.1342L13.2376 9.49734L17.7706 6.63949L12.1363 19.1342ZM13.233 9.49471L9.80115 10.4191L6.36626 11.3356L8.60319 5.9482L13.233 9.49471Z" fill="#41B4E6"/>
                                    <path d="M13.2329 9.49594L8.6029 5.94913L13.8648 3.96769L13.2329 9.49594Z" fill="#73C8F0"/>
                                    <path d="M13.8648 3.96737L8.60286 5.9488L3.05513 6.86376L8.14837 4.23956L13.8648 3.96737Z" fill="#A0EBFF"/>
                                    <path d="M9.80074 10.4199L12.1363 19.1361L13.2373 9.49906L13.2331 9.49664L9.80074 10.4199Z" fill="#77E2FF"/>
                                    <path d="M12.137 19.1347L13.2382 9.49785L17.7713 6.64L12.137 19.1347ZM13.2334 9.4964L9.8011 10.4196L8.60756 5.95202L13.2334 9.4964Z" fill="#1EA6E1"/>
                                    <path d="M13.2329 9.49594L8.60701 5.95157L8.60287 5.94918L13.8648 3.96769L13.2329 9.49594Z" fill="#4EBAEC"/>
                                    <path d="M13.8648 3.96778L8.6028 5.94927L8.14835 4.23997L13.8648 3.96778Z" fill="#77E2FF"/>
                                    <path d="M13.2371 9.49804L17.7702 6.64019L13.8652 3.96777L13.2326 9.49541L13.2371 9.49804Z" fill="#77E2FF"/>
                                </svg>

                                <span>{user ? user.diamonds : 0}</span>
                                
                                Diamonds
                            </div>
                        </>
                    )
                    : (
                        <div className="link">
                            Get diamonds

                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.41797 3.45898L11.9588 6.99982L8.41797 10.5407" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.04199 7H11.8595" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    )
                }
            </div>
            <div className="background">
                <div className="bonus-zone-bg"></div>
            </div>
        </div>
    )
}